const uniqueJoin = names => Array.from(new Set(names.filter(Boolean))).join(', ');

// "Assigned Biller" value for job lists: assigned billers and assigned biller
// groups, comma-separated with duplicates removed.
export const getAssignedBillerDisplay = job =>
  uniqueJoin([
    ...(job?.assignedBiller?.billers || []).map(b => b?.fullName),
    ...(job?.assignedBiller?.billerGroups || []).map(g => g?.groupName)
  ]);

// "Claimed Biller" value for job lists: claimed biller and billing biller,
// comma-separated with duplicates removed.
export const getClaimedBillerDisplay = job =>
  uniqueJoin([job?.claimedBiller?.fullName, job?.biller?.fullName]);
